// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { getAnalytics } from 'firebase/analytics';
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInAnonymously,
  onAuthStateChanged,
  EmailAuthProvider,
  linkWithCredential
} from 'firebase/auth';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

// ✅ Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCBO5rIjsn4pYGTNYOAqSf3p_J0-AWFFvM",
  authDomain: "flourishtalents1.firebaseapp.com",
  projectId: "flourishtalents1",
  storageBucket: "flourishtalents1.appspot.com",
  messagingSenderId: "849498638792",
  appId: "1:849498638792:web:7bb743fa19ccc5a02358fd",
  measurementId: "G-YCH32G4072"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Authentication
const auth = getAuth(app);

// ✅ Automatically sign in anonymously for frictionless access
signInAnonymously(auth).catch(console.error);

onAuthStateChanged(auth, user => {
  if (user) {
    console.log("Signed in (anonymous or regular) as:", user.uid);
    // You can now allow uploads or initialize UI for avatar
  }
});

// ✅ Firestore instance
const db = getFirestore(app);

// ✅ Analytics (optional for now)
const analytics = getAnalytics(app);

const storage = getStorage(app);

// ✅ Helper function to upload avatar image
const uploadAvatar = async (file) => {
  const user = auth.currentUser;
  if (!user) throw new Error("User not signed in");

  const avatarRef = ref(storage, `avatars/${user.uid}/${file.name}`);
  const uploadTask = uploadBytesResumable(avatarRef, file);
  await uploadTask;
  return getDownloadURL(avatarRef);
};

// ✅ Helper function to add form data reusable for all collections to add form data with a custom document ID
//    Now with createdAt timestamp
export async function addFormData(data, collectionName, docId) {
  return setDoc(doc(db, collectionName, docId), {
    ...data,
    createdAt: serverTimestamp()
  });
}

// For checking usernames in the Clients collection
export const checkClientUsernameExists = async (username) => {
  try {
    const docRef = doc(db, "Clients", username);
    const docSnap = await getDoc(docRef);
    return docSnap.exists();
  } catch (error) {
    console.error("Error checking client username:", error);
    throw error;
  }
};

// For checking usernames in the NewPortfolios collection
export const checkTalentUsernameExists = async (username) => {
  try {
    const docRef = doc(db, "NewPortfolios", username);
    const docSnap = await getDoc(docRef);
    return docSnap.exists();
  } catch (error) {
    console.error("Error checking talent username:", error);
    throw error;
  }
};

export const checkUsernameExists = async (username, collectionName = "Clients") => {
  try {
    const docRef = doc(db, collectionName, username);
    const docSnap = await getDoc(docRef);
    return docSnap.exists();
  } catch (error) {
    console.error("Error checking username:", error);
    throw error;
  }
};

// ✅ Export what you need
export {
  db,
  storage,
  uploadAvatar
};


export {
  auth,
  analytics,
  collection,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInAnonymously,
  EmailAuthProvider,
  linkWithCredential
};
